import React from "react";

import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "./RichText.scss";
import { useAppSelector } from "../../hooks";

export interface RichTextProps {
  widget_id: string;
}

export default function RichText({ widget_id }: RichTextProps) {
  const richTexts = useAppSelector(state => state.layouts.richTexts);
  const richText = richTexts
    ? richTexts.find(rt => rt.widget_id === widget_id)
    : null;
  return (
    <div className="rich-text-container">
      {richText ? (
        // "default" is Quill's themeless theme, the same as passing null.
        <ReactQuill value={richText.delta ?? ""} theme="default" readOnly />
      ) : (
        <p className="body-layout-font">
          Custom Text is currently in edit mode
        </p>
      )}
    </div>
  );
}
